<vue-server-messages [messages]="messages"></vue-server-messages>
<vue-modal #modalDefault
           [headerLabel]="'label.AuthorizationCode' | translate | async">
  <p>{{ modalContent }}</p>
  <vue-form-buttons
    [secondaryLabel]="'button.CopyAuthorization' | translate | async"
    (secondaryButtonClicked)="copyAuthorizationCodeToClipboard()">
  </vue-form-buttons>
</vue-modal>
<vue-panel id="TedBackUp"
           i18nBundle="Connect"
           [title]="'label.AuthorizationForm' | translate | async">

       <form name="tedBackupForm"
             class="app-form"
             #tedBackupForm="ngForm">

              <vue-control-group [control]="siteIdInput"
                                 [label]="'label.SiteID' | translate | async"
                                 [formError]="formError">
                     <input class="form-control"
                            type="number"
                            #inputElement
                            #siteIdInput="ngModel"
                            name="siteId"
                            id="siteIdInput"
                            [(ngModel)]="tedBackUpRequest.siteId"
                            (input)="reValidateForm()"
                            autocomplete="off"
                            required
                            vueMinInteger="0">
              </vue-control-group>

              <vue-control-group [control]="registrationIdInput"
                                 [label]="'label.RegistrationId' | translate | async"
                                 [formError]="formError">
                     <input class="form-control"
                            type="number"
                            #inputElement
                            #registrationIdInput="ngModel"
                            name="registrationId"
                            id="registrationIdInput"
                            [(ngModel)]="tedBackUpRequest.registrationId"
                            (input)="reValidateForm()"
                            autocomplete="off"
                            required
                            vueMinInteger="0">
              </vue-control-group>

              <vue-control-group [control]="challengeKeyInput"
                                 [label]="'label.ChallengeKey' | translate | async"
                                 [formError]="formError">
                     <input class="form-control"
                            #inputElement
                            #challengeKeyInput="ngModel"
                            name="challengeKey"
                            id="challengeKeyInput"
                            [(ngModel)]="tedBackUpRequest.challengeKey"
                            (input)="reValidateForm()"
                            autocomplete="off"
                            required
                            vueMaxLength="30">
              </vue-control-group>


              <vue-control-group [control]="userNameInput"
                                 [label]="'label.Username' | translate | async"
                                 [formError]="formError">
                     <input class="form-control"
                            #inputElement
                            #userNameInput="ngModel"
                            name="userName"
                            id="userNameInput"
                            [(ngModel)]="tedBackUpRequest.username"
                            (input)="reValidateForm()"
                            autocomplete="off"
                            required
                            vueMaxLength="50">
              </vue-control-group>


              <vue-control-group [control]="authorizationCountInput"
                                 [label]="'label.AuthorizationCount' | translate | async"
                                 [formError]="formError">
                     <input class="form-control"
                            type="number"
                            #inputElement
                            #authorizationCountInput="ngModel"
                            name="authorizationCount"
                            id="authorizationCountInput"
                            [(ngModel)]="tedBackUpRequest.authorizationCount"
                            (input)="reValidateForm()"
                            autocomplete="off"
                            required
                            vueInteger
                            vueMinInteger="1"
                            vueMaxInteger="99">
              </vue-control-group>
       </form>

       <vue-form-buttons i18nBundle="Connect"
                         [primaryLabel]="'button.GetAuthorization' | translate | async"
                         (primaryButtonClicked)="getAuthorization()">
       </vue-form-buttons>

</vue-panel>